<template>
  <a-modal
    title="信息确认"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item
          v-show="false"
          label="id"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            v-decorator="['id']"
            :disabled="editable || showable"
          />
        </a-form-item>
        <a-form-item
          label="项目"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            v-decorator="['projectName']"
            :disabled="showable"
          />
        </a-form-item>
        <a-form-item
          label="名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            v-decorator="['name']"
            :disabled="showable"
          />
        </a-form-item>
        <a-form-item
          label="规格"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            v-decorator="['format']"
            :disabled="showable"
          />
        </a-form-item>
        <a-form-item
          label="数量"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            v-decorator="['number']"
            :disabled="showable"
          />
        </a-form-item>
        <a-form-item
          label="预付款"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            v-decorator="['advancePay']"
            :disabled="showable"
          />
        </a-form-item>
        <a-form-item
          label="收货备注"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-textarea
            :disabled="showable"
            :rows="3"
            v-decorator="['remark']"
          ></a-textarea>
        </a-form-item>
        <a-form-item
          label="供货商"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            showSearch
            :disabled="editable"
            placeholder="请选择"
            v-decorator="['supplierId']"
            :options="dropSupplierList"
            optionFilterProp="children"
          >
          </a-select>
        </a-form-item>
        <a-form-item
          label="单价"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input-number
            :disabled="editable"
            :precision="3"
            :min="0.000"
            v-decorator="['unitPrice']"
            @change="onPriceChange" />
        </a-form-item>
        <a-form-item
          label="采购备注"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-textarea
            :disabled="editable"
            :rows="3"
            placeholder="请输入采购备注"
            v-decorator="['purchaseRemark']"
          ></a-textarea>
        </a-form-item>
      </a-form>
    </a-spin>
    <template slot="footer">
      <span style="color: red;margin-right: 180px">注：确定后不可更改！</span>
      <a-button key="cancel" @click="handleCancel">取消</a-button>
      <a-button key="forward" :loading="confirmLoading" type="primary" @click="handleOk" v-show="type === 'edit'">保存</a-button>
    </template>
  </a-modal>
</template>

<script>
import { putTreeObj, putMaterialObj, putAssetObj, getTreeObj, getMaterialObj, getAssetObj } from '@/api/common/Purchase'
import { dropSupplierList } from '@/api/common/SxSupplier'
import { FormMixin } from '@/mixins/FormMixin'
import pick from 'lodash.pick'
export default {
  name: 'AddPriceForm',
  mixins: [FormMixin],
  data () {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      },
      type: 'edit',
      visible: false,
      status: '',
      confirmLoading: false,
      dropSupplierList: [],
      category: '',
      showable: false,
      editable: false,
      unitPrice: 0.00,
      form: this.$form.createForm(this)
    }
  },
  methods: {
    edit (id, category, type) {
      this.visible = true
      const { form: { setFieldsValue } } = this
      this.confirmLoading = true
      dropSupplierList().then(res => {
        this.dropSupplierList = res.data
      })
      if (type === 'show') {
        this.type = 'show'
        this.showable = true
        this.editable = true
      }
      if (type === 'edit') {
        this.type = 'edit'
        this.showable = true
        this.editable = false
      }
      if (category === 'tree') {
        getTreeObj(id).then(res => {
          const record = res.data.data
          this.confirmLoading = false
          this.$nextTick(() => {
            setFieldsValue(pick(record, [
              'id',
              'projectName',
              'name',
              'format',
              'number',
              'freight',
              'supplierId',
              'advancePay',
              'purchaseRemark',
              'remark',
              'unitPrice']))
          })
          this.category = 'tree'
        })
      }
      if (category === 'material') {
        getMaterialObj(id).then(res => {
          const record = res.data.data
          this.confirmLoading = false
          this.$nextTick(() => {
            setFieldsValue(pick(record, [
              'id',
              'projectName',
              'name',
              'format',
              'number',
              'freight',
              'supplierId',
              'advancePay',
              'purchaseRemark',
              'remark',
              'unitPrice']))
          })
          this.category = 'material'
        })
      }
      if (category === 'asset') {
        getAssetObj(id).then(res => {
          const record = res.data.data
          this.confirmLoading = false
          this.$nextTick(() => {
            setFieldsValue(pick(record, [
              'id',
              'projectName',
              'name',
              'format',
              'number',
              'freight',
              'supplierId',
              'advancePay',
              'purchaseRemark',
              'remark',
              'unitPrice']))
          })
          this.category = 'asset'
        })
      }
    },
    handleOk () {
      const { form: { validateFields } } = this
      this.confirmLoading = true
      validateFields(async (errors, values) => {
        if (!errors) {
          if (this.category === 'tree') {
            await putTreeObj(values)
          }
          if (this.category === 'material') {
            await putMaterialObj(values)
          }
          if (this.category === 'asset') {
            await putAssetObj(values)
          }
          setTimeout(() => {
            this.visible = false
            this.confirmLoading = false
            this.$emit('ok', values)
          }, 1500)
        } else {
          this.confirmLoading = false
        }
      })
    },
    handleCancel () {
      this.visible = false
      this.unitPrice = 0.00
    },
    onPriceChange (value) {
      // console.log('changed', value)
    }
  }
}
</script>
